module.exports = __webpack_public_path__ + "static/media/notice.bfabc240.png";